export const PricingRoundScalePluginSettings: IPluginSettings = {
    name: 'Шкала округления',
    mnemocode: 'pricing_round_scale_plugin',
    permission: 'Pricing',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'ID',
            visibility: false,
            width: 150
        },
        {
            order: 1,
            propertyName: 'idPricingRoundSchemaGlobal',
            propertyType: 'string',
            displayName: 'ID округления',
            visibility: false,
            width: 200
        },
        {
            order: 2,
            propertyName: 'codePricingRoundMethod',
            propertyType: 'string',
            displayName: 'Тип округление',
            visibility: true,
            width: 200
        },
        {
            order: 3,
            propertyName: 'codePricingRoundPrecision',
            propertyType: 'string',
            displayName: 'Точность округления',
            visibility: true,
            width: 200
        },
        {
            order: 4,
            propertyName: 'priority',
            propertyType: 'number',
            displayName: 'Приоритет',
            visibility: true,
            width: 100
        },
        {
            order: 5,
            propertyName: 'conditionMethod',
            propertyType: 'string',
            displayName: 'Объединение условий',
            visibility: true,
            width: 70
        },
        {
            order: 6,
            propertyName: 'dateCreated',
            propertyType: 'datetime',
            displayName: 'Дата создания',
            visibility: false,
            width: 200
        },
        {
            order: 7,
            propertyName: 'dateModified',
            propertyType: 'datetime',
            displayName: 'Дата последнего изменения',
            visibility: false,
            width: 200
        },
        {
            order: 8,
            propertyName: 'dateDeleted',
            propertyType: 'datetime',
            displayName: 'Дата удаления',
            visibility: false,
            width: 200
        },

    ],
}